"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var ItemTypes_1 = require("../ItemTypes");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var QuoteProductItemBuilder = (function () {
    function QuoteProductItemBuilder(data) {
        this.data = data;
    }
    QuoteProductItemBuilder.new = function () {
        return new QuoteProductItemBuilder({});
    };
    QuoteProductItemBuilder.prototype.withToken = function (token) {
        return new QuoteProductItemBuilder(__assign(__assign({}, this.data), { token: token }));
    };
    QuoteProductItemBuilder.prototype.withProductItemProperties = function (itemProperties) {
        return new QuoteProductItemBuilder(__assign(__assign({}, this.data), { itemProperties: itemProperties }));
    };
    QuoteProductItemBuilder.prototype.forSectionDisplayMode = function (sectionDisplayMode) {
        return new QuoteProductItemBuilder(__assign(__assign({}, this.data), { sectionDisplayMode: sectionDisplayMode }));
    };
    QuoteProductItemBuilder.prototype.build = function () {
        var _a = this.data, token = _a.token, itemProperties = _a.itemProperties, sectionDisplayMode = _a.sectionDisplayMode;
        if (!token) {
            throw new Error("No \"token\" supplied to QuoteProductItemBuilder");
        }
        if (!sectionDisplayMode) {
            throw new Error("No \"sectionDisplayMode\" supplied to QuoteProductItemBuilder");
        }
        return new ItemTypes_1.ItemFactory().templateQuoteItem(Types_1.QuoteItemType.Product, __assign(__assign(__assign({ token: token }, (0, CommonUtils_1.includeIf)(sectionDisplayMode === Types_1.QuoteSectionDisplayMode.PlanCards, {
            interactive: {
                isOptional: true,
                isOptionalSelected: false,
            },
        })), { description: {
                content: "",
                widgets: {},
                tokens: __spreadArray([
                    (0, CommonWidgetRegistry_1.createParagraphToken)(),
                    TokenModels_1.default.variable.createToken(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getProductItemProperties(Types_1.ProductAbstractSubfield.Name, token, itemProperties))
                ], __read((0, CommonUtils_1.includeIf)(sectionDisplayMode === Types_1.QuoteSectionDisplayMode.Table, [
                    TokenModels_1.default.text.createToken(" - "),
                    TokenModels_1.default.variable.createToken(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getProductItemProperties(Types_1.ProductAbstractSubfield.Description, token, itemProperties)),
                ])), false),
            } }), (0, CommonUtils_1.includeIf)(sectionDisplayMode === Types_1.QuoteSectionDisplayMode.PlanCards, {
            featureList: {
                content: "",
                widgets: {},
                tokens: [
                    (0, CommonWidgetRegistry_1.createListItemToken)(),
                    TokenModels_1.default.variable.createToken(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getProductItemProperties(Types_1.ProductAbstractSubfield.Description, token, itemProperties)),
                ],
            },
        })));
    };
    return QuoteProductItemBuilder;
}());
exports.default = QuoteProductItemBuilder;
